// extracted by mini-css-extract-plugin
export var fullHeightState = "_1c-7";
export var headerCell = "_1c-1";
export var loadingStateCell = "_1c-4";
export var rowWrapper = "_1c-3";
export var standaloneTable = "_1c-8";
export var standaloneTableWithBodyFill = "_1c-9";
export var stateCell = "_1c-5";
export var table = "_1c-0";
export var tableBodyFiller = "_1c-6";
export var white = "_1c-2";